import { inject } from '@angular/core';
import { HttpRequest, HttpHandlerFn } from '@angular/common/http';

import { environment } from '@environments/environment';
import { AuthenticationService } from '@services/authentication.service';

export function authInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn) {
  if (!request.url.startsWith(environment.apiUrl)) {
    return next(request);
  }

  const token = inject(AuthenticationService).userValue?.token;
  if (!token) {
    return next(request);
  }

  const newReq = request.clone({
    headers: request.headers.set('Authorization', `Jwt ${token}`)
  });
  return next(newReq);
}